import { AdminCommunitiesStore } from '../../../types/store/admin/communities';
import { initState } from './initState';
import { actions } from './actions';
import { thunks } from './thunks';

export const communities: AdminCommunitiesStore = {
  ...initState,
  ...actions,
  ...thunks,
};
